import { FC } from 'react';
import { Link } from 'react-router-dom';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';

import ButtonRow from '../components/ButtonRow';
import Title from '../components/Title';
import Wrapper from '../components/Wrapper';
import locales from './locales';

const BankAccountNotEmpty: FC = () => (
  <Wrapper>
    <Title>{locales.title}</Title>
    <Text size="sm">{locales.body}</Text>
    <ButtonRow>
      <Button
        as={Link}
        icon="link"
        iconPosition="left"
        to="/payments/transfers/beneficiaries"
      >
        {locales.transferFunds}
      </Button>
    </ButtonRow>
  </Wrapper>
);

export default BankAccountNotEmpty;
